<template>
    <a-card>
        <!-- Default slot -->
        <slot />

        <!-- Show spinner when loading -->
        <div v-if="collection.loading" style="margin:1em">
            <spinner></spinner>
        </div>

        <!-- Show a text if no fields are selected -->
        <div v-if="fields.length <= 0">
            <h1 style="text-align: center;">
                {{ $t('text.selectAtLeastOneField') }}
            </h1>
        </div>

        <!-- Pagination -->
        <div style="margin-bottom: 10px;" v-if="!collection.loading">
            <div>
                <a-pagination
                    v-model="pagination.currentPage"
                    hideOnSinglePage
                    showSizeChanger
                    :page-size.sync="pagination.pageSize"
                    :total="pagination.total"
                    :page-size-options="pageSizeOptions"
                    @change="paginationChanged"
                    @showSizeChange="fetchCollection"
                >
                    <template slot="buildOptionText" slot-scope="props">
                        {{ props.value }} / side
                    </template>
                </a-pagination>
            </div>
        </div>

        <!-- Create the table -->
        <b-table
            v-if="!collection.loading && fields.length > 0"
            class="animated fadeDown"
            hover
            :bordered="false"
            :outlined="false"
            small
            :stacked="$mq == 'sm'"
            responsive="sm"
            :items="dataset"
            :fields="fields"
            :sort-by.sync="sort.by"
            :sort-desc.sync="sort.desc"
            :key="fieldHash"
        >
            <template
                v-for="(field, index) in fields"
                :slot="'cell(' + field.key + ')'"
                slot-scope="row"
            >
                <div :key="field.key">
                    <slot name="actions" v-if="index == 0" v-bind="row" />
                    <slot :name="field.key" v-bind="row">
                        {{ row.item.values[field.key] }}
                    </slot>
                </div>
            </template>
        </b-table>
        <div>
            <div>
                <a-pagination
                    v-if="!collection.loading"
                    v-model="pagination.currentPage"
                    hideOnSinglePage
                    showSizeChanger
                    :page-size.sync="pagination.pageSize"
                    :total="pagination.total"
                    :page-size-options="pageSizeOptions"
                    @change="paginationChanged"
                    @showSizeChange="fetchCollection"
                >
                    <template slot="buildOptionText" slot-scope="props">
                        {{ props.value }} / side
                    </template>
                </a-pagination>
            </div>
        </div>
    </a-card>
</template>

<script>
import Collection from '@/models/GenericCollection'
import Spinner from 'vue-spinner-component/src/Spinner'
import { get } from 'lodash'
import { json2excel } from 'js2excel'

export default {
    props: {
        resourceName: {
            type: String,
            default: 'users',
        },
        query: {
            type: String,
            default: '',
        },
        filter: {
            type: Object,
            default() {
                return {}
            },
        },
        fields: {
            type: Array,
            default() {
                return []
            },
        },
        include: {
            type: Array,
            default() {
                return []
            },
        },
    },
    components: {
        Spinner,
    },
    data() {
        return {
            collection: new Collection().setResourceName(this.resourceName),
            sort: {
                by: null,
                desc: null,
            },
            pageSizeOptions: ['25', '50', '100', '200'],
            pagination: {
                pageSize: 100,
                currentPage: 1,
                total: 100,
            },
            excelLoading: false,
        }
    },
    created() {
        this.collection.setIncludes(this.include.join(','))
        this.collection.setPage(1)
        this.collection.setPerPage(100)
        this.collection.on('fetch', this.fetchSuccess)
        this.fetchCollection()
        window.inz = this
    },
    methods: {
        computedFields() {
            return this.fields
        },

        toggleRow(row) {
            // console.log('toggleRow', row)
            row.toggleDetails()
        },

        getField(item, key) {
            return get(item, key, '')
        },

        fetchSuccess({ err, target }) {
            // Todo: Handle error if any
            if (err) {
                return
            }

            console.log('PaginationOptions', target.getPaginationOptions())

            let pagination = target.getPaginationOptions()
            this.pagination.currentPage = pagination.current_page
            this.pagination.total = pagination.total
            this.pagination.pageSize = pagination.per_page

            // data = data.target
            // this.pagination.total = data.response.data.meta.total
            // this.pagination.currentPage = data.response.data.meta.current_page
            // return data
        },

        prepareCollection(collection) {
            return collection
                .setFilters(this.filter)
                .setIncludes(this.include.join(','))
                .setPerPage(this.pagination.pageSize)
                .setPage(this.pagination.currentPage)
        },

        downloadCollection() {
            // console.log('DownloadCollection')

            let columns = this.fields.map(c => {
                return {
                    key: c.key,
                    path: c.path,
                    label: c.label,
                }
            })

            let formatCollection = item => {
                return columns.reduce((acc, cur) => {
                    acc[cur.label] = get(item, cur.path, '')
                    return acc
                }, {})
            }

            this.excelLoading = true
            let params = {
                query: this.query,
                filter: this.filter,
                include: this.include.join(','),
                page: 1,
                pageSize: this.pagination.total,
            }

            this.prepareCollection(this.$resource(this.resourceName))
                .setPerPage(this.pagination.total)
                .setPage(0)
                .fetch({ params })
                .then(res => {
                    let items = res.getData().data.map(formatCollection)
                    console.log(items, res)
                    json2excel({
                        // Todo: Find a better solution for naming schema
                        name: this.resourceName.split('/')[0],
                        data: items,
                    })
                })
                .finally(() => {
                    this.excelLoading = false
                })
        },

        fetchCollection() {
            let params = {
                query: this.query,
                filter: this.filter,
                include: this.include.join(','),
                page: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
            }

            if (this.sort.by) {
                params.orderBy = this.fields.find(f => {
                    return f.key == this.sort.by
                }).path
            }

            if (this.sort.desc) {
                params.orderDesc = this.sort.desc
            }

            this.prepareCollection(this.collection).fetch({ params: params })
        },

        updateFilter() {
            this.fetchCollection()
        },
        filterUsers() {
            return this.collection.models
        },
        paginationChanged(pageNum) {
            this.pagination.currentPage = pageNum
            // this.pagination.currentPage = page
            this.fetchCollection()
            // console.log('pageChanged', page)
        },
    },
    watch: {
        query(o, n) {
            if (o !== n) {
                this.pagination.currentPage = 1
            }
            this.fetchCollection()
        },
        fields() {
            this.fetchCollection()
        },
        sort: {
            deep: true,
            handler() {
                this.fetchCollection()
            },
        },
        filter: {
            deep: true,
            handler() {
                this.fetchCollection()
            },
        },
    },
    computed: {
        fieldHash() {
            return JSON.stringify(this.field)
        },

        dataset() {
            let columns = this.fields.map(c => {
                return {
                    key: c.key,
                    path: c.path,
                }
            })

            return this.collection.models.map(item => {
                return columns.reduce(
                    (acc, cur) => {
                        acc.values[cur.key] = get(item, cur.path, '')
                        return acc
                    },
                    {
                        data: item,
                        values: {},
                    }
                )
            })
        },

        paginatedUsers() {
            return this.filterUsers()
        },
    },
}
</script>

<style>
.page-item.active .page-link {
    z-index: auto;
}
</style>
